import MyVaroScreen from 'features/myVaro/screens/MyVaroScreen';
import React from 'react';
import SubTabErrorBoundary from 'shared/patterns/wrappers/SubTabErrorBoundary/SubTabErrorBoundary';

export default function MyVaroTab() {
  return (
    <SubTabErrorBoundary>
      <MyVaroScreen />
    </SubTabErrorBoundary>
  );
}
